import React, { useEffect, useState } from 'react';
import { hot } from 'react-hot-loader';
import { addEvent, removeEvent } from '../../../utils/dom';
import s from './Spacer.scss';

const Spacer = ({ content }) => {
	const initialHeight = content.height || content;
	if (!initialHeight) return null;
	const [height, updateHeight] = useState(parseInt(initialHeight, 10));

	useEffect(() => {
		let currentlyMobile = true;
		const resizeSpacer = () => {
			if (window.innerWidth < 600 && !currentlyMobile) {
				updateHeight(Math.round(content / 2));
				currentlyMobile = true;
			} else if (window.innerWidth >= 600 && currentlyMobile) {
				updateHeight(content);
				currentlyMobile = false;
			}
		};

		addEvent(window, 'resize.spacer', () => {
			window.requestAnimationFrame(resizeSpacer);
		});

		resizeSpacer();

		return () => {
			removeEvent(window, 'resize.spacer');
		};
	});

	return <div className={s.spacer} style={{ height: `${height}px` }} />;
};

export default hot(module)(Spacer);
